import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMinus = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "16px",
	height: "16px",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "icons / minus" }),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("path", {
			d: "M1,2 L15,2 C15.5522847,2 16,1.55228475 16,1 C16,0.44771525 15.5522847,0 15,0 L1,0 C0.44771525,0 0,0.44771525 0,1 C0,1.55228475 0.44771525,2 1,2 Z",
			id: "path-1"
		}) }),
		/* @__PURE__ */ _jsx("g", {
			id: "icons-/-minus",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsxs("g", {
				transform: "translate(0, 7)",
				children: [
					/* @__PURE__ */ _jsx("mask", {
						id: "mask-2",
						fill: "white",
						children: /* @__PURE__ */ _jsx("use", { xlinkHref: "#path-1" })
					}),
					/* @__PURE__ */ _jsx("use", {
						id: "Shape",
						fill: "#000000",
						fillRule: "nonzero",
						xlinkHref: "#path-1"
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "COLOR/-black",
						mask: "url(#mask-2)",
						fill: "#000000",
						children: /* @__PURE__ */ _jsx("g", {
							transform: "translate(-4, -11)",
							id: "Rectangle",
							children: /* @__PURE__ */ _jsx("rect", {
								x: 0,
								y: 0,
								width: 24,
								height: 24
							})
						})
					})
				]
			})
		})
	]
});
export default SvgMinus;
